import { render, staticRenderFns } from "./BarChartVisitacao.vue?vue&type=template&id=3dec8b85"
import script from "./BarChartVisitacao.vue?vue&type=script&lang=js"
export * from "./BarChartVisitacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports